import { OrderFormat as e } from "@ancon/wildcat-types";
const r = [
  e.EatIn,
  e.TakeAway,
  e.Delivery,
  e.TableOrder,
  e.BoxPickup
], o = "YYYY-MM-DD", l = 7, n = 60, a = 1 * 60;
export {
  r as OnlineOrderFormatsArray,
  n as OutletClosingLabelThreshold,
  o as OutletMapKeyFormatter,
  l as OutletTimelineDayCount,
  a as WoltMinimumScheduleDropOffTime
};
